import { render, staticRenderFns } from "./operateBtn.vue?vue&type=template&id=5aea4b9e"
import script from "./operateBtn.vue?vue&type=script&lang=js"
export * from "./operateBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports